<template lang="html">
  <div class="allComments">
    <table v-for="(c, index) in profileComments"
      :key="c.commentId || index">

      <menu-tp
        v-if="user"
        style="float: right;"
        icon="more_horiz"
        :like="user && user.id == c.authorId? 'ownComment' : 'report'"
        @edit="edit(c.commentId)"
        @delete="$emit('delete', c.commentId)"
      />

      <tr class="tr">
        <th>
          <ul>
            <md-avatar class="avatarComment">
              <img :src="c.profileImg" alt="People">
            </md-avatar>
          </ul>
        </th>

        <th class="thTextComments">
          <ul class="ulNameComment">
            <div class="">
              <span class="nameComment">{{ c.fullName || c.name }}</span>
            </div>
          </ul>

          <ul class="ulDateComment">
            <div >
              <span class="dateComment">{{ date(c.createdAt) }}</span>
            </div>
          </ul>

          <ul class="ulComment">
            <div v-if="currentComment == c.commentId">
              <md-field>
                <md-textarea v-model="editComment" maxlength="1000"></md-textarea>
              </md-field>

              <md-button
                class="md-raised md-primary buttonSend"
                type="submit"
                :disabled="editComment == '' || editSubmit != false && editSubmit != 'error'"
                :md-ripple="false"
                @click="$emit('edit', c.commentId, editComment)"
              >
                <span v-show="editSubmit == false">
                  Enviar
                  <md-icon class="md-primary iconSend">send</md-icon>
                </span>
                <loader v-show="editSubmit == 'loading'"/>
                <span v-show="editSubmit == 'error'">Erro!</span>
                <span v-show="editSubmit == true">Enviado!</span>
              </md-button>
            </div>
            <div v-else>
              <p class="comment">{{ c.content }}</p>
            </div>
          </ul>

        </th>
      </tr>

      <tr v-show="index < profileComments.length - 1">
        <ul>
          <div class="dividerComment">
          <md-divider class="md-inset"></md-divider>
          </div>
        </ul>
      </tr>

    </table>
  </div>
</template>

<script>
import menuTp from "@/components/shared/menuTemplate";
import loader from "@/components/shared/loader";

export default {
  name: "comments",
  props: ["comments", "profiles", "editSubmit"],
  components: {
    menuTp,
    loader
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      currentComment: null,
      editComment: ''
    }
  },
  computed: {
    profileComments() {
      if(!this.profiles)  return this.comments;
      let pc = [];
      let author = {};
      for(let comment of this.comments) {
        author = this.matchAuthor(comment.authorId);
        comment.profileImg = author.profileImg;
        comment.fullName = author.fullName;
        comment.name = author.name;
        pc.push(comment);
      }
      return pc;
    }
  },
  watch: {
    editSubmit(status) {
      if (status == true) {
        this.currentComment = null;
        this.editComment = '';
      }
    }
  },
  methods: {
    date(literalDate) {
      let locale = "pt-BR";
      if(literalDate)
        return new Date(literalDate).toLocaleString(locale);
      return null
    },
    matchAuthor(author) {
      if(Array.isArray(this.profiles))
        return this.profiles.find(profile => profile.id == author);
      else return this.profiles;
    },
    edit(commentId) {
      this.currentComment = commentId;
      this.editComment = this.comments.find(comment => comment.commentId == commentId).content;
      this.$emit('resetEdit');
    }
  },
};
</script>

<style scoped>
.allComments {
  width: 100%;
}

table {
  width: 100%;
}

ul {
  padding: 0;
}

.tr {
  display: flex;
}

.thTextComments {
  text-align: left;
}

.buttonReply {
  left: 80px;
  bottom: 5px;
  max-width: 100px;
  border-radius: 50px;
}

.buttonSend {
  left: 0;
  width: 8em;
  border-radius: 50px;
}

.iconSend {
  margin-left: 10%;
}

.md-list {
  background: none;
}

.divAvatarAndLike {
  display: contents;
  width: 50px;
  height: 9em;
  margin: auto;
  float: left;
}

.LikeComment {
  float: left;
  margin: 0.5em auto;
}

.ulNameComment {
  padding-left: 1em;
  margin-bottom: 0;
}

.divTextComment {
  width: 500px;
  margin: auto;
}

.nameComment {
  display: contents;
  text-align: initial;
  font-size: 16px;
  font-weight: 500;
  float: left;
}

.ulDateComment {
  padding-left: 1em;
  margin-top: 0;
}

.dateComment {
  display: contents;
  text-align: initial;
  width: 100px;
  font-weight: 100;
  margin: 0;
  float: left;
}

.ulComment {
  padding-left: 1em;
  word-break: break-word;
}

.comment {
  display: contents;
  text-align: initial;
  margin: 0 auto;
  word-wrap: break-word;
  float: left;
}

.md-divider {
  margin-left: 0;
}
</style>
